import React, { useEffect } from "react";
import { useSearchParams } from 'react-router-dom';
import { useAnalytics } from '../hooks/analytics/useAnalytics';
import { SCREEN_NAMES } from '../constants/analytics';
import { queryRequest } from '../services/internalApi';

export function PrivilegedMemberTermsOfService() {
    const [searchParams] = useSearchParams();
    const userToken = searchParams.get('user_token') || null;

    // ページ表示情報をアナリティクスに送信する
    const analytics = useAnalytics();

    useEffect(() => {
        if (!userToken) return;

        queryRequest(`
            query ($userToken: String!) {
                getMemberIdFromUserToken(userToken: $userToken) {
                    common {
                        statusCode
                        message
                    }
                    memberId
                }
            }
        `, {
            variables: { userToken }
        })
            .then((result) => {
                const fetchedMemberId = result.data.getMemberIdFromUserToken?.memberId ?? null;

                if (fetchedMemberId !== null) {
                    // ユーザーIDを設定（既に同じIDが設定されている場合はスキップされる）
                    analytics.setAnalyticsUserId(fetchedMemberId);
                    // データ取得完了後にアナリティクスを送信
                    analytics.trackScreenView(SCREEN_NAMES.PRIVILEGED_MEMBER_TERMS_OF_SERVICE);
                }
            })
            .catch((err) => {
                console.error('Error fetching member id for terms of service analytics:', err);
            });
        // マウント時に一度だけ実行する意図的な設計(analyticsはuseMemoで参照が安定しているため省略可)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div className="App">
            <div className="App-background">
                <div className="App-base" style={{backgroundColor: 'white'}}>
                    <div className="App-body">
                        <div style={{textAlign: 'center', paddingTop: '2em'}}>
                            <span style={{color: '#333'}}>ご利用規約</span>
                        </div>
                        <div style={{color: '#333', padding: '1em', wordBreak: 'break-all'}}>
                            <>
                                <p>【カンテイモバイル利用規約】</p>
                                <p>株式会社東京カンテイ(以下「当社」といいます)は、当社が提供するサービスである「カンテイモバイル」（以下「本サービス」といいます）に関しての利用規約（以下「本規約」といいます）を以下の通り定めます。ご利用に際しては、本規約の全文をお読みいただき、その内容を十分に理解してご同意いただく必要があります。本規約にご同意いただけない場合は、本サービスを利用することはできません。なお、初回起動時に求められる利用者情報を登録した時点で、本規約に同意したものとします。</p>
                                <br/>
                                <p>第一章</p>
                                <p>第1条（規約の適用）</p>
                                <ol>
                                    <li>本規約は、本サービスの全ての利用に関し適用されるものとします。</li>
                                    <li>本規約とは別に当社が別途定める諸規定（会員制データサービス入会時に交わした情報システム利用に関する契約書を含むが、それに限られない。以下「個別規定等」といいます）は、それぞれ本規約の一部を構成するものとします。</li>
                                    <li>本規約の規定と前項の個別規定等の内容が異なる場合には、個別規定等の内容が優先して適用されるものとします。</li>
                                </ol>
                                <p>第2条（規約の変更と通知）</p>
                                <p>当社は、会員（第3条に定義。以下同じ。）の事前の承諾を得ることなく、本規約および個別規定等（以下「本規約等」といいます）を変更することができるものとします。なお、通知なく変更することができ、変更後の本規約は、本サービスに掲載するものとし、掲載後、効力を生じます。</p>
                                <p>第3条（会員）</p>
                                <p>会員とは、会員入会希望者が別途定める手続きに従って、入会をすることにより、本サービスの提供を受けることが可能となった者をいいます。ただし、会員は、日本国内に居住し、国内郵便で配達可能な所在地に住所を有している必要があります。</p>
                                <br/>
                                <p>第二章 本サービスの利用</p>
                                <p>第4条（本サービス）</p>
                                <ol>
                                    <li>本サービスの内容は、当社の判断により、変更、追加等することができるものとします。</li>
                                    <li>電子メール、郵便物等が会員の事情または会員が契約する通信事業会社の事情等当社の責めに帰さない事由により会員に到達しない場合、当社は、各サービスに関する対応等をしません。また、それにより会員に損害が発生した場合であっても当社は一切の責任を負いません。</li>
                                    <li>当社は、本サービス提供のために取得した個人情報の処理を外部に委託することがあります。この場合、当社と委託先との間で個人情報の保護を義務づける契約を締結し、処理を委託した個人情報について適切な管理を行います。</li>
                                    <li>以下の場合、当該会員は、本サービスを受けることができませんので、ご注意ください。
                                        <ol>
                                            <li>本サービスの登録情報の内容に虚偽または不備があった場合</li>
                                            <li>その他、本サービスの利用に関して不正行為があった場合</li>
                                        </ol>
                                    </li>
                                    <li>利用者の端末・通信回線・ブラウザの種類などの環境によって、本サービスの一部または全部を利用することができない場合、当社は一切の責任を負いません。</li>
                                    <li>本サービスを受ける際に必要な費用（インターネット接続料や通信料等）は会員の負担となります（トラブル等については、当社は責任を負わないものとします）。</li>
                                    <li>本サービスの利用の際に登録された情報の権利は、当社に帰属します。</li>
                                </ol>
                                <br/>
                                <p>第5条（禁止事項）</p>
                                <p>当社は、会員が次の行為を行うことを禁止します。</p>
                                <p>(1)
                                    本サービスに関する著作権、商標権、肖像権等の知的財産権等を侵害する行為またはそのおそれがある行為。</p>
                                <p>(2) 他の会員になりすまして本サービスを利用する行為。</p>
                                <p>(3) メールアドレス等、本サービス・特典等を第三者に譲渡する行為。</p>
                                <p>(4) 当社または第三者を誹謗中傷する行為。</p>
                                <p>(5) 当社または第三者に不利益を与える行為。</p>
                                <p>(6) 本サービスの運営を妨げるような行為。</p>
                                <p>(7)
                                    前各号の他、本規約等、法令または公序良俗に違反する行為若しくはそれらのおそれがある行為。</p>
                                <p>(8) 前各号の行為を第三者に行わせる行為。</p>
                                <br/>
                                <p>第三章 個人情報の取扱い</p>
                                <p>第6条 （会員に関する情報の取扱い）</p>
                                <ol>
                                    <li>当社は、本サービスに関して会員が当社に対して提供する、氏名、生年月日、メールアドレス等の会員を認識もしくは特定できる個人情報ならびに当社に記録される会員による本サービスの利用履歴（以下2つをあわせて「会員情報等」といいます）を、善良なる管理者としての注意を払って管理いたします。</li>
                                    <li>会員は、当社が会員情報等を、本サービスを提供する目的（会員本人からの問い合わせ対応や料金の請求等を含みます）の他に、以下の各号に定める目的に利用することがあることに同意するものとします。
                                        <ol>
                                            <li>当社が会員に対し、本サービスの追加または変更のご案内、または緊急連絡の目的で、電子メールや郵便等で通知する場合、または電話等により連絡すること。</li>
                                            <li>当社の提供するサービスや商品に関する広告宣伝またはその他の案内を、電子メールもしくは郵便等で通知する場合、または電話等により連絡する場合、もしくは会員がアクセスした本サイト上その他会員の情報端末機器の画面上に表示すること。</li>
                                            <li>会員情報等を適切に管理するように契約等により義務付けた業務委託先に対し、委託業務を行う上で必要な範囲内において委託すること。</li>
                                            <li>当社が本サービスの向上等を目的として、利用動向を把握するために、会員情報等を集計及び分析等すること。</li>
                                            <li>市場調査、需要予測その他経営上必要な分析を行うための基礎データの収集並びに特定の個人を識別することができない統計的データの作成及びその公表すること。</li>
                                            <li>法的な義務を伴う開示要求へ対応すること。</li>
                                            <li>その他法令の規定に基づき提供しなければならないこと。</li>
                                            <li>人の生命、身体及び財産等に対する差し迫った危険があり、緊急の必要性があること。</li>
                                            <li>その他任意に本人に事前に同意を得たうえで会員情報等を開示または利用すること。</li>
                                        </ol>
                                    </li>
                                    <li>
                                        当社は、会員情報等の保有期間については、以下の通りとするものとします。
                                        <ol>
                                            <li>会員情報・案件管理ノートに関する情報・サクット媒介契約・マイページに影響を及ぼす数値は無期限。</li>
                                            <li>それ以外については、1年間で削除。</li>
                                        </ol>
                                    </li>
                                    <li>その他会員情報等の取扱いについては、当社の「個人情報保護方針」をご参照ください。 <br/> https://kanteimobile-web.tokyokantei.com/privacy-policy
                                    </li>
                                </ol>
                                <br/>
                                <p>第7条 （会員情報等の第三者への提供の制限）</p>
                                <p>当社は、会員情報等を、前条の利用目的または次の各号の一に該当する場合を除き、会員の同意を得ないで第三者（当社が利用目的の達成に必要な範囲内において、会員情報等の取扱いの全部または一部を委託するものを除く。）に対して提供しないものとします。</p>
                                <ol>
                                    <li>法令に基づき請求される場合。</li>
                                    <li>緊急を要する等のため、会員の同意を得ることが困難であると当社が認める場合。</li>
                                    <li>公的機関から請求される場合。</li>
                                    <li>その他サービスの運営上必要であると当社が判断する場合。</li>
                                </ol>
                                <p>会員からの個人情報保護方針に関する問い合わせ、その他当社の個人情報保護方針は以下を参照ください。 <br/> https://kanteimobile-web.tokyokantei.com/privacy-policy
                                </p>
                                <br/>
                                <p>第四章 その他</p>
                                <p>第8条（著作権等）</p>
                                <ol>
                                    <li>本サービスにより提供されるすべてのコンテンツ等の著作権、著作隣接権、肖像権、商標権等の一切の権利は、当社または当社が許諾を受けたコンテンツプロバイダ等の第三者に帰属しています。会員は、当該コンテンツ等を、本規約等を遵守したうえで各サービスの目的でのみ利用でき、複製、販売、貸与、公衆送信(送信可能化を含みます。)、改変、翻案その他の方法により利用することは一切禁止されます。</li>
                                    <li>当社は会員に当該違反行為がある場合及び違反行為のおそれがある場合には、速やかに当該違反行為を停止するよう求めることができます。また、会員の当該違反行為により、当社または権利者に損害が発生した場合には、会員に損害の賠償を求めることがあります。</li>
                                </ol>
                                <br/>
                                <p>第9条（本サービス提供の中断）</p>
                                <ol>
                                    <li>当社は、以下のいずれかに該当する場合は本サービスを中断できるものとします。なお、当社は本サービスの中断について、緊急を要する場合を除き事前に第2条に従い会員に告知するものとします。
                                        <ol>
                                            <li>定期的な点検の場合。</li>
                                            <li>緊急の点検、本サービス用設備の保守上や工事上やむを得ない場合。</li>
                                            <li>火災、停電、天災地変、感染症の流行、国家非常事態など不可抗力により本サービスの提供が行えなくなった場合。</li>
                                            <li>通信事業者が電気通信サービスを中断あるいは中止、提供することができなくなった場合。</li>
                                            <li>その他、運営上中断が必要であると当社が判断した場合。</li>
                                        </ol>
                                    </li>
                                    <li>当社は、本サービスのための設備等が不足し本サービスを提供することができないと当社が判断した場合には、問題が解消されるまで会員に対し本サービスの利用を制限することができます</li>
                                </ol>
                                <br/>
                                <p>第10条（利用停止等）</p>
                                <ol>
                                    <li>当社は、会員が次のいずれかに該当する場合は、本サービスの利用停止、または会員資格の停止、失効、停止、解除（以下「利用停止等措置」といいます）をすることができるものとします。
                                        <ol>
                                            <li>会員が本規約に違反し、または違反するおそれがあると当社が判断した場合。</li>
                                            <li>本規約での会員の禁止事項に該当する行為を行った場合。</li>
                                            <li>本サービスに関する料金等の支払債務の履行遅延または不履行があった場合。</li>
                                            <li>会員が死亡した場合等会員が権利能力を失った場合。</li>
                                            <li>会員情報等が会員の不注意な管理により流出し、第三者による不正利用が行われた場合、あるいはそのおそれがあると当社が判断した場合。</li>
                                            <li>本サービスの運営を妨害、または当社の名誉信用を毀損した場合。</li>
                                            <li>その他、会員として不適切または本サービスの提供に支障があると当社が判断した場合。</li>
                                            <li>その他、当社業務の運営遂行に支障をきたすと当社が判断した場合。</li>
                                        </ol>
                                    </li>
                                    <li>前項による利用停止等措置については、会員に対し、利用停止等措置の日時や期間などを通知して行います。また、この場合、第2条に定めた会員に対する通知方法によって通知します。</li>
                                    <li>利用停止等措置がなされた場合、当該会員は、期限の利益を失い、かかる措置の日までに発生した本サービスに関連する当社に対する債務の全額（日割り計算しないものとします）を、当社の指示する方法で一括して支払うものとします。</li>
                                    <li>当社は、利用停止等措置の際、会員が既に支払った利用料金等の払い戻し請求、その他利用停止等措置に伴う会員からの損害賠償の請求からも免責されるものとします。</li>
                                </ol>
                                <br/>
                                <p>第11条（第三者への委託）</p>
                                <p>当社は、本サービス及び本規約等に基づく当社の業務の全部または一部を提携事業者（当社と提携する事業者であり、メール送受信、認証、課金及び代金回収等の業務を行う当社のパートナーをいいます）を含む第三者に委託して行わせることができるものとします。</p>
                                <br/>
                                <p>第12条 （本サービスの終了）</p>
                                <ol>
                                    <li>当社は、1か月前までに会員に対して第2条に従い通知することにより、会員に対する本サービスの提供を中止することができるものとします。</li>
                                    <li>前項の場合でも、支払済みの会費等の返還・減額などは一切行いません。</li>
                                </ol>
                                <br/>
                                <p>第13条（反社会的勢力の排除）</p>
                                <ol>
                                    <li>
                                        会員は、自らが、現在、暴力団、暴力団員、暴力団員でなくなった時から5年を経過しない者、暴力団準構成員、暴力団関係企業、総会屋等、社会運動等標ぼうゴロ、または特殊知能暴力集団、その他これらに準ずる者（以下「暴力団員等」といいます）、及び次の各号のいずれにも該当しないことを表明し、かつ将来にわたっても該当しないことを保証します。
                                        <ol>
                                            <li>自己もしくは第三者の不正の利益を図る目的または第三者に損害を加える目的をもってするなど、不正に暴力団員等を利用していると認められる関係を有するものとします。</li>
                                            <li>暴力団員等に対して資金等を提供し、または便宜を供与するなどの関与をしていると認められる関係を有するものとします。</li>
                                        </ol>
                                    </li>
                                    <li>当社は、会員が暴力団員等もしくは前項各号のいずれかに該当することが判明したときは、会員に何らの通知・催告をすることなく、直ちに、本サービスに関する契約を解除するものとします。</li>
                                    <li>当社は、前項の規定により解除した場合、かかる解除に関して会員が損害を被ったときであっても、これを賠償または補償する責任を一切負わないものとします。また、会員が暴力団員等もしくは前項各号のいずれかに該当することが判明したことにより当社が何らかの損害、損失または費用負担（弁護士費用の負担を含みます。）を被った場合、会員は、当社の請求に従って直ちにこれらを補償しなければならないものとします。</li>
                                </ol>
                                <br/>
                                <p>第14条（免責および責任の制限）</p>
                                <ol>
                                    <li>当社は、本サービスならびに会員が本サービスを通じて得る情報等について、その完全性、正確性、確実性、有用性、継続性等につき、いかなる保証も行わないものとします。</li>
                                    <li>本サービスの提供、遅滞、変更、中止、本サービスを通じて登録、提供もしくは収集された会員情報等の情報の消失、その他本サービスに関連して発生した会員の損害について、当社は、当社に帰責性のない限り、一切責任を負わないものとします。</li>
                                    <li>当社以外の第三者の責に帰すべき事由によって、会員が本サービスの全部または一部を利用できないことにつき、当社は一切の責任を負いません。</li>
                                    <li>当社は、本サービスを提供すべき場合において、もっぱら当社の責めに帰すべき事由により、本サービスの提供を全く利用できない状態（本サービスの利用に関し著しい支障が生じ、全く利用できない状態と同程度の状態となる場合を含みます。）にあることを当社が知った時刻から起算して、その状態が本サービスの利用可能期間のうち3分の１を超えて継続したときに限り、当該会員への損害賠償に応じます。</li>
                                    <li>本規約等及び本サービスに関して、当社が負担する損害賠償の範囲は当該会員に現実に発生した通常損害に限り、また、賠償額は当該損害が発生した月に当該会員の支払った料金を上限といたします。ただし、当社に故意または重過失がある場合を除きます。</li>
                                </ol>
                                <br/>
                                <p>第15条（譲渡禁止）</p>
                                <ol>
                                    <li>会員は、会員たる地位ならびに本規約が有する権利及び義務を当社の事前の同意を得ることなく第三者に譲渡してはならないものとします。</li>
                                    <li>相続により、会員たる地位ならびに本規約上会員が有する権利及び義務は承継されません。</li>
                                    <li>当社は、本サービスにかかる事業の一部または全部を他社に譲渡した場合（通常の事業譲渡に限らず、会社分割等その他の事業移転を含みます。）には、当該事業譲渡に伴い、本サービス上の地位、本規約等に基づく権利義務ならびに会員情報等を当該事業譲渡の譲受人に譲渡することができるものとし、会員はこれを予め同意したものとします。</li>
                                </ol>
                                <br/>
                                <p>第16条（退会等）</p>
                                <ol>
                                    <li>当社は、会員が、当社の行う本サービスに競合する業務を行い、会員にふさわしくないと当社が判断した場合は、催告を要せずして当該会員を退会させることができるものとします。</li>
                                    <li>会員が宅地建物取引業者の免許の登録その他その業を行うのに必要な免許または登録等を取消、抹消等により失ったときは、会員の資格を失うものとします。</li>
                                    <li>前項のほか、会員が法令に違反しまたは本個別規定の条項に一つでも違反した場合において、当社による催告後相当期間内にこれを是正できないときには、当社は情報システムの提供を停止することまたは退会させることができるものとします。</li>
                                    <li>当社は会員に対し、会員が係る情報システムの提供の停止または退会により被った損害の賠償責任を一切負わないものとします。</li>
                                    <li>本サービス退会後、当社が会員に対し、提供したデータ等その他一切の情報を引渡す義務はないものとし、会員はこれを異議なく承諾するものとします。</li>
                                </ol>
                                <br/>
                                <p>第17条 （準拠法）</p>
                                <p>この規約の成立、効力、履行及び解釈に関しては、日本国法が適用されるものとします。</p>
                                <br/>
                                <p>第18条（専属的合意管轄裁判所）</p>
                                <p>当社及び会員は、当社と会員との間でこの規約及びサービスの利用に関して訴訟の必要が生じた場合、東京地方裁判所または東京簡易裁判所を第一審の専属的合意管轄裁判所とするものとします。</p>
                                <br/>
                                <p>第19条（取得データの利用）</p>
                                <p>当社は、本サービスの履行において取得した情報を、当社の裁量で、本サービスの提供及び運用、サービス内容の改良及び向上、本サービスの利用状況の把握の目的のために利用し、かつ、新サービスの開発、データの商業利用、その他の目的のために利用することができるものとします。</p>
                                <br/>
                                <p>この規約は2023年10月18日から施行します。</p>
                                <br/>
                                ------------------------------<br/>
                                <br/>
                                <p>特定商取引法に基づく表記</p>
                                事業者：株式会社東京カンテイ<br />
                                住所：東京都品川区上大崎3丁目8番3号<br />
                                サービス名：カンテイモバイル<br />
                                販売責任者：長田 千江美<br />
                                電話番号：03-5719-3011<br />
                                メールアドレス：kiyoshi.nakamura@kantei.co.jp<br />
                                URL：https://www.kantei.ne.jp/<br /><br />
                                商品引き渡し時期：決済登録後、即ご提供可能となります。<br />
                                支払方法：固定料金を毎月初にクレジットカード等で決済頂きます。<br />
                                返品・キャンセル：返品、キャンセルは商品の性質上受け付けておりません。<br />
                            </>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
